import api from "./index";
import { ENDPOINTS } from "./endpoints";

export const getBuyerOverview = ()=>
  api.get(ENDPOINTS.BUYER_OVERVIEW.DASHBOARD);